import { render, staticRenderFns } from "./Menulists.vue?vue&type=template&id=299a20c5"
import script from "./Menulists.vue?vue&type=script&lang=js"
export * from "./Menulists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports